import { put, call } from 'redux-saga/effects';
import { getDataSuccess } from '../slices/dataSlice';

const calldataAPI = async (action) => {

  return await fetch(`${process.env.REACT_APP_PUBLIC_URL}/datas/${action.payload.url}`,{
      headers : {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
       }
    })
    .then(response => {
      return response.json()
    })
    .catch(err => { console.log(err); return false; })
}
export default function* dataAPI(action) {

  try {
    let response = yield call(() => calldataAPI(action));
    yield put( getDataSuccess(response) )
  } catch (error) {
    console.log(error)
  }
}
